import { render, staticRenderFns } from "./StudentNoteItem.vue?vue&type=template&id=2ce0f71f&scoped=true&"
import script from "./StudentNoteItem.vue?vue&type=script&lang=js&"
export * from "./StudentNoteItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentNoteItem.vue?vue&type=style&index=0&id=2ce0f71f&lang=scss&scoped=true&"
import style1 from "./StudentNoteItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce0f71f",
  null
  
)

export default component.exports